module.exports = __webpack_public_path__ + "assets/images/skulls/7.svg";